import React from "react";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { toast } from "react-toastify";
import { auth, db, provider, storage } from "../firebaseconfig/firebase";
import { setDoc, doc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { FaEyeSlash } from "react-icons/fa";
import { IoEyeSharp } from "react-icons/io5";
import { GiPadlock } from "react-icons/gi";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const Register = () => {
  const [firstName, setFirstName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [avatar, setAvatar] = React.useState(null);
  const [userName, setUserName] = React.useState("");
  const [isAuth, setIsAuth] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState("");
  const [register, setRegister] = React.useState(false);
  const [shortUserDescription, setShortUserDescription] = React.useState("");

const navigate = useNavigate();



  const registerwithemailandpassword = async (event) => {
    event.preventDefault();
    if (
      !firstName ||
      !lastName ||
      !email ||
      !password ||
      !userName ||
      !avatar
    ) {
      alert("All fields are required");
      return;
    }
    setRegister(true)
    try {
      // event.preventDefault();
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      localStorage.setItem("isAuth", true);
      setIsAuth(true);
      // const User = auth.currentUser;
      // console.log(User);
      // alert("REGISTERATION SUCCESSFUL PLS LOGIN TO CONTINUE");
      // toast.success("REGISTERATION SUCCESSFUL PLS LOGIN TO CONTINUE", {
      //   position: "top-center",
      // });
      const user = userCredential.user;
      let avatarURL = "";

    if (avatar) {
      const avatarRef = ref(storage, `avatars/${user.uid}`);
      await uploadBytes(avatarRef, avatar);
      avatarURL = await getDownloadURL(avatarRef);
    }
      if (user) {
        await setDoc(doc(db, "users", user.uid), {
          email: user.email,
          firstname: firstName,
          lastname: lastName,
          createdAt: new Date(),
          photoURL: avatarURL,
          userName: userName,
          password: password,
          UserDescription: shortUserDescription,
        });
      }
      console.log(user);
      alert("REGISTERATION SUCCESSFUL PLS LOGIN TO CONTINUE");
      toast.success("REGISTERATION SUCCESSFUL PLS LOGIN TO CONTINUE", {
        position: "top-center",
      });
      navigate("/home");
    } catch (error) {
      console.log(error.message);
      toast.error(error, {
        position: "top-center",
      });
    }
  };

  const signInWithGoogle = async (event) => {
    try {
      event.preventDefault();
      await signInWithPopup(auth, provider);
      localStorage.setItem("isAuth", true);
      toast.success("REGISTERATION SUCCESSFUL PLS LOGIN TO CONTINUE", {
        position: "top-center",
      });
      setIsAuth(true);
      navigate("/home");
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      const email = error.customData.email;
      console.log(errorCode, errorMessage, email);
    }
  };

  return (
    <div className="bg-blue-950">
      <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Create an Account
          </h2>

          <form className="flex flex-col gap-5">
            {/* First Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                First Name
              </label>
              <input
                type="text"
                required
                placeholder="John"
                onChange={(e) => setFirstName(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg
                     focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Last Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Last Name
              </label>
              <input
                type="text"
                required
                placeholder="Doe"
                onChange={(e) => setLastName(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg
                     focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Username */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Username
              </label>
              <input
                type="text"
                required
                placeholder="Username"
                // value="@"
                onChange={(e) => setUserName(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg
                     focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                maxLength={29}
                required
                placeholder="name@email.com"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg
                     focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <label>Password</label>
            <div className="relative">
              <GiPadlock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 size-8" />
              <input
                onChange={(e) => setPassword(e.target.value)}
                type={showPassword ? "text" : "password"}
                className="border-2 border-gray-300 h-14 bg-transparent rounded-md w-full pl-14"
                placeholder="Enter your Password"
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
              >
                {showPassword ? (
                  <FaEyeSlash size={22} />
                ) : (
                  <IoEyeSharp size={22} />
                )}
              </span>
            </div>

            {/* UPLOAD  A PICTURE  */}
            <div>
              <label>Profile Picture</label>
              <div className="w-full p-6 h-24 border-2 border-gray-600 bg-gray-500">
                <input
                  type="file"
                  required
                  onChange={(e) => setAvatar(e.target.files[0])}
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              onClick={registerwithemailandpassword}
              className="mt-4 w-full py-3 rounded-lg bg-blue-600 text-white font-semibold
                   hover:bg-blue-700 transition duration-200
                   disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {register ? "Registering..." : "Register"}
            </button>

            {/* Footer text */}
            <p className="text-sm text-center text-gray-500 mt-3">
              Already have an account?{" "}
              <span className="text-blue-600 hover:underline cursor-pointer">
                <Link to="/"> Log in </Link>
              </span>
            </p>
          </form>
        </div>
      </div>

      {/* <form className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            First Name
          </label>
          <input
            onChange={(e) => setFirstName(e.target.value)}
            required
            type="text"
            placeholder="JOHN"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            LASTNAME
          </label>
          <input
            onChange={(e) => setLastName(e.target.value)}
            type="text"
            required
            placeholder="DOE"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            maxLength={29}
            type="email"
            required
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@email.com"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-500"
          />

          <label className="block text-sm font-medium text-gray-700 mb-1">
            Password
          </label>
          <input
            maxLength={19}
            type="password"
            required
            onChange={(e) => setPassword(e.target.value)}
            placeholder="**** **** **** ****"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-500"
          />
        </div>
        <button
          type="submit"
          className="w-full py-2 bg-blue-500 text-white rounded-md"
          onClick={registerwithemailandpassword}
        >
          Register
        </button>
        <button
          type="submit"
          className="bg-gray-200"
          onClick={signInWithGoogle}
        >
          REGISTER WITH GOOGLE
        </button>
      </form> */}
    </div>
  );
};

export default Register;
